var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCanvasPref(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9641_4263)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.16667 0H0V9.16667H9.16667V0ZM6.96973 0.833333L1.85607 5.94699L3.21971 7.31062L8.33337 2.19696L6.96973 0.833333ZM1.51516 6.28786L0.833333 8.33333L2.87881 7.65152L1.51516 6.28786Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2298 3.61111H11.6321V7.22222C11.6321 7.68246 11.9898 8.05556 12.431 8.05556C12.8721 8.05556 13.2298 7.68246 13.2298 7.22222V3.61111Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1667 0H10V9.16667H19.1667V0ZM14.0286 0.833333H10.8333V1.38889H11.3659V7.22222C11.3659 7.83587 11.8427 8.33333 12.431 8.33333C13.0192 8.33333 13.4961 7.83587 13.4961 7.22222V1.38889H14.0286V0.833333ZM14.5611 2.08333H18.3333V2.87037H14.5611V2.08333ZM14.5611 3.65741H18.3333V4.44444H14.5611V3.65741ZM14.5611 5.23148H18.3333V6.01852H14.5611V5.23148ZM14.5611 6.80556H18.3333V7.59259H14.5611V6.80556Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.22396 13.4115C6.61228 13.4115 6.92708 13.0967 6.92708 12.7083C6.92708 12.32 6.61228 12.0052 6.22396 12.0052C5.83563 12.0052 5.52083 12.32 5.52083 12.7083C5.52083 13.0967 5.83563 13.4115 6.22396 13.4115Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.51515 11.1742C1.3447 11.1742 1.17424 11.3447 1.17424 11.5152V17.6515C1.17424 17.822 1.3447 17.9924 1.51515 17.9924H7.65152C7.82197 17.9924 7.99242 17.822 7.99242 17.6515V11.5152C7.99242 11.3447 7.82197 11.1742 7.65152 11.1742H1.51515ZM7.65152 11.8561V16.6288L5.60606 14.5833L4.92424 15.2652L3.90152 13.9015L1.51515 16.6288V11.8561C1.51515 11.6856 1.68561 11.5152 1.85606 11.5152H7.31061C7.48106 11.5152 7.65152 11.6856 7.65152 11.8561Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.16667 10H0V19.1667H9.16667V10ZM0.833333 11.5365C0.833333 11.1742 1.17 10.8333 1.51515 10.8333H7.65152C7.99667 10.8333 8.33333 11.1742 8.33333 11.5152V17.6515C8.33333 17.9967 7.99242 18.3333 7.65152 18.3333H1.51515C1.17424 18.3333 0.833333 17.9967 0.833333 17.6515V11.5365Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 12.5V14.1667H12.5V12.5H16.6667Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1667 10H10V19.1667H19.1667V10ZM16.6667 11.6667H12.5V12.5H11.6667V14.1667H12.5V15H16.6667V16.6667H12.5V15.8333H11.6667V16.6667H12.5V17.5H16.6667V16.6667H17.5V12.5H16.6667V11.6667Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.833333 19.1667H19.1667V20H0.833333V19.1667Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1667 0.833333H20V20H19.1667V0.833333Z",
    fill: "current"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9641_4263"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanvasPref);
export default __webpack_public_path__ + "static/media/CanvasPref.713a8dbed5b5dfafec86a89391c58913.svg";
export { ForwardRef as ReactComponent };